/* @flow */
import React from 'react';
import { Route, Redirect } from 'react-router';

import JoinGroupPage from './components/JoinGroupPage.jsx';
import JoinView from './components/JoinView.jsx';
import JoinInfoPage from './components/JoinInfoPage.jsx';
import JoinRolePicker from './components/JoinRolePicker.jsx';
import JoinSearchPage from './components/JoinSearchPage.jsx';
import JoinConfirmEmailDevicePage from './components/JoinConfirmEmailDevicePage.jsx';
import JoinConfirmSmsDevicePage from './components/JoinConfirmSmsDevicePage.jsx';
import JoinOrganizationPage from './components/JoinOrganizationPage.jsx';
import JoinSignUpPage from './components/JoinSignUpPage.jsx';
import JoinClaimDirectAddAccount from './components/JoinClaimDirectAddAccount.jsx';
import ConfirmOrganizationPage from './components/ConfirmOrganizationPage.jsx';
import { goToClassCodeIfAuthed } from 'lib/RouteLogic';

export default (
  <Route component={JoinView}>
    {/* Ask a bunch of info is required then transtion to Groups */}
    <Route
      path="/information_required"
      component={JoinInfoPage}
    />

    {/*
      Same as InformationRequired
      but try to subscribe to the group when everything is done and transition to it.
    */}
    <Route
      path="/information_required/:groupCode"
      component={JoinInfoPage}
    />

    {/* Role picker, that will redirect to groups */}
    <Route
      path="/join/role_picker"
      component={JoinRolePicker}
    />

    {/*
      Role picker, that will try to subscribe to the classe code
      and transition either to InformationRequired or Groups.
    */}
    <Route
      path="/join/role_picker/:groupCode"
      component={JoinRolePicker}
    />

    <Route
      path="/join(/)"
      component={JoinSearchPage}
    />

    <Route
      path="/join/claim_account"
      component={JoinClaimDirectAddAccount}
    />

    <Redirect from="/subscribe(/)" to="/join" />
    <Redirect from="/subscribe/:groupCode" to="/join/:groupCode" />

    <Route
      path="/join/:groupCode"
      component={JoinGroupPage}
      onEnter={goToClassCodeIfAuthed}
    />

    {/* Email subscribers are sent here to confirm the subscriptions */}
    <Route
      path="/join/:groupCode/info"
      component={JoinConfirmEmailDevicePage}
    />


    {/* SMS subscribers are sent here to confirm the subscriptions */}
    <Route
      path="/join/:groupCode/sms"
      component={JoinConfirmSmsDevicePage}
    />

    <Route
      path="/sign_up"
      component={JoinSignUpPage}
    />

    <Route
      path="/school/join/:id"
      component={JoinOrganizationPage}
      onEnter={JoinOrganizationPage.onEnter}
    />

    <Route
      path="/school/confirm/:id"
      component={ConfirmOrganizationPage}
      onEnter={ConfirmOrganizationPage.onEnter}
    />
  </Route>
);



// WEBPACK FOOTER //
// ./src/join/routes.js